<template>
  <div id="shop-confirm">
    <!-- header image -->
    <v-container fluid pa-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 sm6 xs12>
          <v-img :src="require('@/assets/shop/shop_header.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- content -->
    <v-container grid-list-xl pt-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 px-0 sm8 xs12>
          <v-img :src="require('@/assets/shop/shop_header-1.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row text-xs-center wrap>
        <v-flex sm6 xs10>
          <div class="display-1 font-weight-bold">ขอบคุณที่ใช้บริการ</div>
          <div class="subheading my-2">สินค้าของคุณจะถูกจัดส่งถึงที่หมาย ภายใน 1 อาทิตย์</div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row text-xs-center wrap>
        <v-flex sm6 xs10>
          <div class="subheading my-2">สามารถสอบถามข้อมูลเพิ่มเติมได้ที่</div>
          <div class="display-1 font-weight-bold">093 317 1414</div>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-center row text-xs-center wrap>
        <v-flex sm4 xs10>
          <v-btn
            block
            @click="$router.push({ name: 'home' })"
            color="primary"
            depressed
            large
            style="border-radius:8px"
            >กลับหน้าหลัก</v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'shop-confirm',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
